module.exports = __webpack_public_path__ + "static/media/arrows-red.c97ce314.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/arrows-red.gif
// module id = 113
// module chunks = 0